import React from 'react';

const KolayCRMPrivacy = () => {
  return (
    <div className="min-h-screen bg-white text-gray-800 px-6 py-16">
      <h1 className="text-4xl font-bold mb-6 text-center">Gizlilik Politikası</h1>
      <p className="text-center text-gray-600 mb-4">Son Güncelleme: Mayıs 2026</p>
      <hr className="my-6" />

      <div className="max-w-3xl mx-auto space-y-6 text-justify leading-relaxed">
        <p>
          KolayCRM uygulaması (“uygulama”), kullanıcılarının gizliliğine büyük önem verir.
          Bu gizlilik politikası, uygulamanın hangi verileri topladığını, bu verileri nasıl
          kullandığını ve nasıl koruduğunu açıklar.
        </p>

        <h2 className="text-xl font-semibold mt-8">1. Toplanan Veriler</h2>
        <p>
          Uygulama, kullanıcı deneyimini geliştirmek ve temel işlevleri sunmak amacıyla aşağıdaki bilgileri toplayabilir:
        </p>
        <ul className="list-disc ml-6 space-y-1">
          <li>E-posta adresi: Firebase Authentication aracılığıyla kayıt ve giriş işlemleri için.</li>
          <li>Apple Kimliği bilgileri: “Apple ile Giriş Yap” kullanıldığında Apple tarafından sağlanan ad ve e-posta (kullanıcı gizleme tercihine saygı gösterilir).</li>
          <li>İşletme bilgileri: Kullanıcının kendi isteğiyle girdiği işletme/şirket adı, sektör, telefon numarası.</li>
          <li>İş verileri: Kullanıcının uygulama içinde oluşturduğu müşteri, ürün/hizmet, satış, tahsilat/borç, randevu ve teklif kayıtları.</li>
          <li>Ekip verileri: Çok kullanıcılı çalışma alanı (workspace) için üye rolleri, davet kodları ve üyelik bilgileri.</li>
          <li>Teknik veriler: Uygulamanın düzgün çalışması için cihaz türü, sistem versiyonu gibi anonim teknik bilgiler.</li>
        </ul>
        <p>
          Uygulama hiçbir zaman konum, fotoğraf, kişi listesi veya mikrofon verisi toplamaz.
          Uygulamada herhangi bir reklam veya üçüncü taraf izleme SDK’sı bulunmaz.
        </p>

        <h2 className="text-xl font-semibold mt-8">2. Verilerin Kullanımı</h2>
        <p>
          Toplanan veriler yalnızca aşağıdaki amaçlarla kullanılır:
        </p>
        <ul className="list-disc ml-6 space-y-1">
          <li>Kullanıcı hesabının doğrulanması ve yönetilmesi</li>
          <li>Müşteri, satış, tahsilat ve teklif işlemlerinin güvenli biçimde saklanması</li>
          <li>Çok kullanıcılı çalışma alanı içinde rol bazlı veri erişiminin sağlanması</li>
          <li>Uygulama performansının iyileştirilmesi</li>
          <li>Kullanıcının isteğiyle işletme bilgilerinin düzenlenmesi</li>
        </ul>
        <p>
          Veriler hiçbir koşulda üçüncü şahıslarla paylaşılmaz veya satılmaz.
        </p>

        <h2 className="text-xl font-semibold mt-8">3. Verilerin Saklanması ve Güvenliği</h2>
        <p>
          Tüm veriler Google Firebase altyapısında (Authentication ve Firestore) güvenli biçimde depolanır.
          Firebase, endüstri standartlarında güvenlik önlemleri (SSL, kimlik doğrulama, erişim kontrolü) uygular.
          Verilere yalnızca ilgili çalışma alanının yetkili üyeleri erişebilir.
        </p>
        <p>
          Kullanıcı, hesabını istediği zaman silebilir veya verilerinin kaldırılması için geliştiriciyle iletişime geçebilir.
        </p>

        <h2 className="text-xl font-semibold mt-8">4. Ücretlendirme ve Abonelik</h2>
        <p>
          Uygulama, ücretsiz deneme sürümünün yanı sıra ücretli (Pro) abonelik planları sunar.
          Abonelik satın alma ve yenileme işlemleri Apple App Store üzerinden gerçekleştirilir;
          ödeme bilgileriniz (kredi kartı vb.) doğrudan Apple tarafından işlenir ve uygulama bu bilgilere erişmez.
        </p>
        <p>
          Abonelik durumunuzun yönetimi için RevenueCat altyapısı kullanılabilir. Bu kapsamda,
          satın alma doğrulaması ve abonelik durumunun belirlenmesi amacıyla anonim bir kullanıcı kimliği
          ve satın alma bilgileri işlenebilir. Bu veriler reklam veya pazarlama amacıyla kullanılmaz.
        </p>
        <p>
          Fiyatlandırmada yapılacak değişikliklerde kullanıcılar önceden bilgilendirilecektir.
        </p>

        <h2 className="text-xl font-semibold mt-8">5. İletişim</h2>
        <p>
          Herhangi bir soru, öneri veya veri silme talebi için bizimle iletişime geçebilirsiniz:
        </p>
        <p className="ml-4">
          E-posta: <a href="mailto:hi@n1inovasyon.com" className="text-blue-600">hi@n1inovasyon.com</a><br />
        </p>

        <h2 className="text-xl font-semibold mt-8">6. Değişiklikler</h2>
        <p>
          Bu gizlilik politikası zaman zaman güncellenebilir.
          En güncel sürüm uygulama içinden veya web sitemizden görüntülenebilir.
        </p>
      </div>
    </div>
  );
};

export default KolayCRMPrivacy;
